export default __webpack_public_path__ + "static/media/Flaticon.5b9118b4.svg";